import React, { Component } from "react";
import { Row, Col, Container, Modal } from "react-bootstrap";
import moment from "moment";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import "./_permissionDetails.scss";
import "./_studentPermission.scss";


const ADD_PERMISSION_DETAILS = gql`
  mutation($params: AddPermissionDetails) {
    addPermissionDetails(params: $params)
  }`;

class PermissionDetailsModal extends Component {
    constructor() {
        super();
        this.state = {
            comments: "",
            commentsError: "",
            submitError: "",
            submitted: false,
            loader: 0,
            dataClear: 1
        };
    }

    handleChange = (e) => {
        this.setState({ comments: e.target.value, commentsError: "" });
    }

    handleSubmit = (value) => {
        if (value === "2" && !this.state.comments.trim()) {
            this.setState({ commentsError: "Please enter a reason for declining this request." });
            return;
        }

        const params = {
            permission_id: this.props.stateData.individualPermissionData.permission_id,
            permission_status: parseInt(value),
            permission_type_id: 1,
            approved_by: parseInt(Cookies.get("id")) || 1,
            comments: this.state.comments
        };

        this.setState({ loader: 1, submitError: "", commentsError: "" });

        this.addPermissionDetails(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message).join(", "), loader: 0 });
        });

        setTimeout(() => { this.props.onHide(); }, 2500);
    }

    addPermissionDetails = async (params) => {
        await this.props.addPermissionDetails({
            variables: { params },
            update: (store, { data }) => {
                if (data.addPermissionDetails) {
                    this.setState({ loader: 0, submitted: true });
                    setTimeout(() => { window.location.reload(true); }, 2000);
                }
            }
        });
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({ comments: "", commentsError: "", submitError: "", submitted: false, loader: 0, dataClear: 1 });
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 });
        }
    }

    render() {
        const d = this.props.stateData.individualPermissionData;
        const fromDate = d.from_datetime ? moment.unix(d.from_datetime).format("DD MMM YYYY, hh:mm A") : "--";
        const toDate   = d.to_datetime   ? moment.unix(d.to_datetime).format("DD MMM YYYY, hh:mm A")   : "--";
        const outTime  = d.outtime       ? moment.unix(d.outtime).format("DD MMM YYYY, hh:mm A")        : null;
        const inTime   = d.intime        ? moment.unix(d.intime).format("DD MMM YYYY, hh:mm A")         : null;

        const isPending  = this.props.stateData.blockType == "1" || d.permission_status == null;
        const isAccepted = !isPending && (this.props.stateData.blockType == "2" || d.permission_status == "1");
        const isDeclined = !isPending && !isAccepted;

        const headerClass = isPending ? "perm-modal-header-pending" : isAccepted ? "perm-modal-header-accepted" : "perm-modal-header-declined";
        const headerIcon  = isPending ? "fa-clock" : isAccepted ? "fa-check-circle" : "fa-times-circle";
        const headerTitle = isPending ? "Permission Request" : isAccepted ? "Accepted Permission" : "Declined Permission";

        return (
            <Modal {...this.props} size="lg" aria-labelledby="permission-details-modal">
                <Modal.Header closeButton className={headerClass} style={{ borderBottom: "none" }}>
                    <Modal.Title className="modal-title">
                        <i className={`fas ${headerIcon} mr-2`} />{headerTitle}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ background: "#F8FAFC", padding: "28px 28px 20px" }}>
                    {/* ── Request message banner ── */}
                    {d.request_message && (
                        <div className="perm-request-banner">
                            <i className="fas fa-quote-left mr-2" style={{ opacity: 0.5 }} />
                            {d.request_message}
                        </div>
                    )}

                    <Row>
                        {/* ── Left: receiver info ── */}
                        <Col lg={5} sm={12} className="mb-3">
                            <div className="perm-info-card">
                                <p className="perm-section-heading"><i className="fas fa-user mr-1" />Receiver Details</p>

                                {d.receiver_image_path && (
                                    <div className="mb-3">
                                        <img src={d.receiver_image_path} alt="receiver" className="perm-avatar" />
                                    </div>
                                )}

                                <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 12 }}>
                                    {[
                                        { icon: "fa-user", label: "Name", value: d.receiver_name, color: "#7c3aed" },
                                        { icon: "fa-phone-alt", label: "Mobile", value: d.receiver_mobile, color: "#0891b2" },
                                        { icon: "fa-user-friends", label: "Relation", value: d.receiver_relation, color: "#16a34a" },
                                    ].map((r) => (
                                        <div key={r.label} style={{ display: "flex", alignItems: "center", gap: 12, background: "#fff", border: "1px solid #eef2f7", borderRadius: 12, padding: "10px 12px" }}>
                                            <div style={{ width: 38, height: 38, borderRadius: 10, background: `${r.color}15`, color: r.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, flexShrink: 0 }}>
                                                <i className={`fas ${r.icon}`} />
                                            </div>
                                            <div style={{ minWidth: 0 }}>
                                                <div style={{ fontSize: 10, fontWeight: 800, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.6px" }}>{r.label}</div>
                                                <div style={{ fontSize: 15, fontWeight: 700, color: "#1e293b", wordBreak: "break-word", lineHeight: 1.3 }}>{r.value || "--"}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Comments (view-only for accepted/declined) */}
                                {(isAccepted || isDeclined) && (
                                    <>
                                        <p className="perm-field-label mb-1">{isDeclined ? "Rejection Reason" : "Comments"}</p>
                                        <textarea
                                            value={d.comments || (isDeclined ? "No reason provided." : "")}
                                            disabled
                                            className="perm-input"
                                            rows={3}
                                            style={{
                                                background: isDeclined ? "#FEF2F2" : "#F8FAFC",
                                                borderColor: isDeclined ? "#FECACA" : "#E2E8F0",
                                                color: "#334155"
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        </Col>

                        {/* ── Right: timings ── */}
                        <Col lg={7} sm={12} className="mb-3">
                            <div className="perm-info-card" style={{ height: "auto", alignSelf: "flex-start" }}>
                                <p className="perm-section-heading"><i className="fas fa-clock mr-1" />Requested Timings</p>
                                <Row className="mb-0">
                                    {[
                                        { key: "from", label: "From", value: fromDate, icon: "fa-sign-out-alt", accent: "#7c3aed", tint: "#f5f3ff", border: "#ddd6fe" },
                                        { key: "to", label: "To", value: toDate, icon: "fa-sign-in-alt", accent: "#0891b2", tint: "#ecfeff", border: "#a5f3fc" },
                                    ].map((t) => {
                                        const empty = !t.value || t.value === "--";
                                        return (
                                            <Col sm={6} className="mb-0" key={t.key}>
                                                <div style={{ borderRadius: 12, padding: "12px 14px", background: empty ? "#f8fafc" : t.tint, border: `1.5px solid ${empty ? "#e2e8f0" : t.border}` }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                                                        <div style={{ width: 30, height: 30, borderRadius: 8, background: empty ? "#cbd5e1" : t.accent, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, flexShrink: 0 }}>
                                                            <i className={`fas ${t.icon}`} />
                                                        </div>
                                                        <span style={{ fontSize: 11, fontWeight: 800, color: empty ? "#94a3b8" : t.accent, textTransform: "uppercase", letterSpacing: "0.6px" }}>{t.label}</span>
                                                    </div>
                                                    <div style={{ fontSize: 14, fontWeight: 700, color: empty ? "#94a3b8" : "#1e293b" }}>{empty ? "Not set" : t.value}</div>
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </Row>

                                {/* Exit / Entry snapshots (accepted only) */}
                                {isAccepted && outTime && (
                                    <Row className="mb-3">
                                        <Col sm={12}>
                                            <p className="perm-section-heading mt-2"><i className="fas fa-sign-out-alt mr-1" />Exit Snapshot</p>
                                        </Col>
                                        <Col sm={6}>
                                            <p className="perm-field-label mb-1">Exit Time</p>
                                            <div className="div_box">{outTime}</div>
                                        </Col>
                                        <Col sm={6} className="d-flex align-items-center">
                                            {d.outtime_image_path && (
                                                <img src={d.outtime_image_path} alt="exit" className="perm-snapshot mt-2" />
                                            )}
                                        </Col>
                                    </Row>
                                )}

                                {isAccepted && inTime && (
                                    <Row className="mb-2">
                                        <Col sm={12}>
                                            <p className="perm-section-heading mt-2"><i className="fas fa-sign-in-alt mr-1" />Entry Snapshot</p>
                                        </Col>
                                        <Col sm={6}>
                                            <p className="perm-field-label mb-1">Entry Time</p>
                                            <div className="div_box">{inTime}</div>
                                        </Col>
                                        <Col sm={6} className="d-flex align-items-center">
                                            {d.intime_image_path && (
                                                <img src={d.intime_image_path} alt="entry" className="perm-snapshot mt-2" />
                                            )}
                                        </Col>
                                    </Row>
                                )}

                                {/* Comments input for pending */}
                                {isPending && d.permission_request_type_id != 2 && (
                                    <div className="mt-3">
                                        <p className="perm-section-heading"><i className="fas fa-comment-alt mr-1" />Your Comment</p>
                                        <textarea
                                            onChange={this.handleChange}
                                            value={this.state.comments}
                                            placeholder="Required when declining. Optional for acceptance."
                                            className={`perm-input${this.state.commentsError ? " is-invalid" : ""}`}
                                            rows={3}
                                        />
                                        {this.state.commentsError && (
                                            <span className="perm-error-text"><i className="fas fa-exclamation-circle" />{this.state.commentsError}</span>
                                        )}
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>

                    {/* ── Action buttons (pending only) ── */}
                    {isPending && d.permission_request_type_id != 2 && (
                        <div style={{ background: "#fff", borderRadius: 12, padding: "16px 20px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                            <div className="d-flex align-items-center" style={{ gap: 14, flexWrap: "wrap" }}>
                                <button className="btn-accept-perm" onClick={() => this.handleSubmit("1")} disabled={this.state.loader === 1}>
                                    {this.state.loader === 1
                                        ? <span className="spinner-border spinner-border-sm" />
                                        : <i className="fas fa-check" />
                                    }
                                    Accept Request
                                </button>
                                <button className="btn-decline-perm" onClick={() => this.handleSubmit("2")} disabled={this.state.loader === 1}>
                                    {this.state.loader === 1
                                        ? <span className="spinner-border spinner-border-sm" />
                                        : <i className="fas fa-times" />
                                    }
                                    Decline Request
                                </button>

                                {this.state.submitted && (
                                    <div className="perm-alert perm-alert-success">
                                        <i className="fas fa-check-circle" />Status updated successfully!
                                    </div>
                                )}
                                {this.state.submitError && (
                                    <div className="perm-alert perm-alert-error">
                                        <i className="fas fa-exclamation-circle" />{this.state.submitError}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

export default withRouter(compose(
    graphql(ADD_PERMISSION_DETAILS, { name: "addPermissionDetails" })
)(PermissionDetailsModal));
